(function () {
	"use strict";

	if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position){
            position = position || 0;
            return this.substr(position, searchString.length) === searchString;
        };
    }

}());


// WEBPACK FOOTER //
// ./assets/js/modules/shared/polyfills.js